<template>
  <b-checkbox class="checkbox" v-model="value.data" />
</template>

<script>
export default {
  name: 'c-checkbox',
  props: ['value'],
}
</script>

<style scoped>
.checkbox {
  position: absolute;
  width: 20px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/Checkbox.vue